import React from "react";
import { AuthenticationManager, ResourceID } from "../../../common/AuthenticationManager";
import { GenericMessages } from "../../../common/Constants";
import { StringHelper } from "../../../common/Helpers";
import RestClient from "../../../common/RestClient";
import { BreadCrumb } from "../../common/BreadCrumb";
import { ConfirmDialog } from "../../common/ConfirmDialog";
import { CancelPreviewButton } from "../common/CancelPreviewButton";
import { CardMode } from "../common/CardMode";
import { VoucherTypeDetailCard } from "./cards/VoucherTypeDetailCard";
import { VoucherTypePreview } from "./preview/VoucherTypePreview";
import {
  NavigationItem,
  NavigationSettings,
} from "../../common/NavigationSettings";
import { toast } from "react-toastify";
import ButtonActionDetailGroup from "../../common/ButtonActionDetailGroup";

const EditPageName = "Edit Scheduled Movie Voucher";
const ViewPageName = "View Scheduled Movie Voucher";

export class ScheduledVoucherTypeDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardMode: CardMode.ScheduleView,
      generalInfo: null,
      generalInfoValidations: [],
      scheduledVoucherType: null,
      scheduledVoucherTypeId: "",
      showCancelDialog: false,
      showConfirmDialog: false,
      showPreview: false,
      showDeleteModal: false,
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    const scheduledVoucherTypeId = StringHelper.toNumber(id, 0);
    if (isNaN(id) || scheduledVoucherTypeId <= 0) {
      this.redirectToListingPage();
      return;
    }
    this.setState({ scheduledVoucherTypeId }, this.refreshData);
  }

  isValidated() {
    const { generalInfoValidations } = this.state;
    return generalInfoValidations.every((val) => val.isValid);
  }

  loadscheduledVoucherType(id) {
    RestClient.sendGetRequest(
      `/api/v1/scheduled_voucher_types/${id}`,
      (response) => {
        this.setState({ scheduledVoucherType: response });
      },
      (errorResponse) => {
        toast.error(errorResponse.message);
      }
    );
  }

  onEditScheduledVoucherTypeClick = () => {
    this.setState({ cardMode: CardMode.ScheduleUpdate });
  };

  onGeneralInfoModelChange = (model) => {
    const displayStartTime = StringHelper.toDateTimeString(
      model.displayStartTimeStr
    );
    const displayEndTime = StringHelper.toDateTimeString(
      model.displayEndTimeStr
    );
    const planToPublish = StringHelper.toDateTimeString(model.planToPublishStr);
    const category = StringHelper.toNumber(model.category, 0);
    const weightDisplay = StringHelper.toNumber(model.weightDisplay, 0);
    const newModel = Object.assign(model, {
      category,
      displayStartTime,
      displayEndTime,
      planToPublish,
      weightDisplay,
    });
    this.setState({ generalInfo: newModel });
  };

  onGeneralInfoValidationsChange = (validations) => {
    this.setState({ generalInfoValidations: validations });
  };

  onHideCancelDialog = () => {
    this.setState({ showCancelDialog: false });
  };

  onHideConfirmDialog = () => {
    this.setState({ showConfirmDialog: false });
  };

  onHidePreview = () => {
    this.setState({ showPreview: false });
  };

  onProceedCancelDialog = () => {
    this.setState({
      cardMode: CardMode.ScheduleView,
      scheduledVoucherType: Object.assign({}, this.state.scheduledVoucherType),
      showCancelDialog: false,
    });
  };

  onProceedConfirmDialog = () => {
    if (!this.isValidated()) {
      this.setState({ isSubmit: true, showConfirmDialog: false });
      return;
    }
    const { generalInfo, scheduledVoucherTypeId } = this.state;
    const request = Object.assign(
      {},
      generalInfo
    );
    RestClient.sendPutRequest(
      `/api/v1/scheduled_voucher_types/${scheduledVoucherTypeId}`,
      request,
      (response) => {
        toast.success(GenericMessages.SaveChangesSuccessfulMessage);
        this.setState({
          cardMode: CardMode.ScheduleView,
          isSubmit: false,
          scheduledVoucherType: response,
          showConfirmDialog: false,
        });
      },
      (errorResponse) => {
        toast.error(errorResponse.message);
        this.setState({
          showConfirmDialog: false,
        });
      }
    );
  };

  onShowCancelDialog = () => {
    this.setState({ showCancelDialog: true });
  };

  onShowConfirmDialog = () => {
    if (!this.isValidated()) {
      this.setState({ isSubmit: true });
      return;
    }
    this.setState({ showConfirmDialog: true });
  };

  onShowPreview = () => {
    this.setState({ showPreview: true });
  };

  refreshData() {
    const { scheduledVoucherTypeId } = this.state;
    this.loadscheduledVoucherType(scheduledVoucherTypeId);
  }

  redirectToListingPage(additionalParameter) {
    this.props.history.push(
      `/movie_vouchers/schedules/${additionalParameter ?? ""}`
    );
  }

  getNavigationSettings = () => {
    const { cardMode } = this.state;
    return new NavigationSettings({
      rootModule: new NavigationItem({
        identifier: "website_managements",
        name: "Website Management",
      }),
      parentModule: new NavigationItem({
        identifier: "movie_vouchers",
        name: "Movie Vouchers",
      }),
      activeModule: new NavigationItem({
        identifier: "movie-voucher-details",
        name: CardMode.isViewMode(cardMode) ? ViewPageName : EditPageName,
      }),
    });
  };

  onProceedDelete = () => {
    const { scheduledVoucherTypeId } = this.state;
    RestClient.sendDeleteRequest(
      `/api/v1/scheduled_voucher_types/${scheduledVoucherTypeId}`,
      () => {
        toast.success("The scheduled voucher type has been deleted successful.");
        this.redirectToListingPage();
      }, (errorResponse) => {
        toast.error(errorResponse.message);
      }
    );
    this.setState({ showDeleteModal: false });
  }

  onDelete = () => {
    this.setState({ showDeleteModal: true });
  };

  onCancel = () => {
    this.setState({ showDeleteModal: false });
  };

  render() {
    const {
      cardMode,
      isSubmit,
      generalInfo,
      scheduledVoucherType,
      showCancelDialog,
      showConfirmDialog,
      showPreview,
      showDeleteModal,
    } = this.state;
    if (showPreview) {
      const previewModel = Object.assign(
        {},
        generalInfo
      );
      return (
        <>
          <VoucherTypePreview voucherType={previewModel} />
          <CancelPreviewButton onClick={this.onHidePreview} />
        </>
      );
    }
    return (
      <div className="main-content">
        <BreadCrumb navigationSettings={this.getNavigationSettings()} />
        <div className="section__content section__content--p30">
          <div className="container-fluid">
            {CardMode.isViewMode(cardMode) && (
              <div className="row mb-3">
                <div className="col">
                  <div className="d-flex flex-row-reverse">
                    {AuthenticationManager.isAuthorized(
                      ResourceID.MovieVoucherScheduledEditButtonPage
                    ) && (
                        <>
                          <button
                            className="btn btn-primary ml-2 mb-2"
                            value="Edit"
                            disabled={scheduledVoucherType ? undefined : "disabled"}
                            onClick={this.onEditScheduledVoucherTypeClick}
                          >
                            <i className="fas fa-edit"></i> Edit
                          </button>
                          <button
                            className="btn btn-danger ml-2 mb-2"
                            value="Delete Schedule"
                            disabled={scheduledVoucherType ? undefined : "disabled"}
                            onClick={this.onDelete}
                          > Delete Schedule
                          </button>
                        </>
                      )
                    }
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-md-12">
                <VoucherTypeDetailCard
                  cardMode={cardMode}
                  defaultValue={scheduledVoucherType}
                  isSubmit={isSubmit}
                  model={generalInfo}
                  onModelChange={this.onGeneralInfoModelChange}
                  onValidationsChange={this.onGeneralInfoValidationsChange}
                />
              </div>
            </div>
            {CardMode.isEditMode(cardMode) && (
              <ButtonActionDetailGroup>
                <ButtonActionDetailGroup.Item
                  className="btn btn-outline-secondary"
                  onClick={this.onShowPreview}
                >
                  Preview
                </ButtonActionDetailGroup.Item>
                <ButtonActionDetailGroup.Item
                  className="btn btn-success"
                  onClick={this.onShowConfirmDialog}
                >
                  Save Changes
                </ButtonActionDetailGroup.Item>
                <ButtonActionDetailGroup.Item
                  className="btn btn-danger"
                  onClick={this.onShowCancelDialog}
                >
                  Cancel
                </ButtonActionDetailGroup.Item>
              </ButtonActionDetailGroup>
            )}
          </div>
        </div>
        <ConfirmDialog
          visible={showCancelDialog && scheduledVoucherType}
          onCancel={this.onHideCancelDialog}
          onProceed={this.onProceedCancelDialog}
          message={GenericMessages.CancelChangesDialogMessage}
          title={GenericMessages.CancelChangesDialogTitle}
        />
        <ConfirmDialog
          visible={showConfirmDialog && scheduledVoucherType}
          onCancel={this.onHideConfirmDialog}
          onProceed={this.onProceedConfirmDialog}
          message={GenericMessages.SaveChangesDialogMessage}
          title={GenericMessages.SaveChangesDialogTitle}
        />
        <ConfirmDialog
          visible={showDeleteModal}
          message={"Are you sure you want to delete this scheduled voucher type?"}
          onProceed={this.onProceedDelete}
          onCancel={this.onCancel}
        />
      </div>
    );
  }
}
